import 'jquery.easing';
import './plugins/utility';
import HOME from './module/home';
import INIT from './module/init';


INIT();

switch( location.pathname ){
  case '/': HOME(); break
}